(function () {
  'use strict';

  // ── Inject CSS ─────────────────────────────────────────────────────
  // Self-contained: no separate stylesheet needed.
  if (!document.getElementById('c9-combo-unavail-css')) {
    var style = document.createElement('style');
    style.id = 'c9-combo-unavail-css';
    style.textContent =
      // Faded + not-allowed cursor on the label
      '.product-form__input--pill label.c9-combo-unavail{' +
        'opacity:.42;' +
        'position:relative;' +
        'cursor:not-allowed;' +
      '}' +
      // Diagonal strikethrough via ::after pseudo-element
      '.product-form__input--pill label.c9-combo-unavail::after{' +
        'content:"";' +
        'position:absolute;' +
        'inset:0;' +
        'pointer-events:none;' +
        'border-radius:inherit;' +
        'background:linear-gradient(' +
          'to top right,' +
          'transparent calc(50% - 0.5px),' +
          'currentColor calc(50% - 0.5px),' +
          'currentColor calc(50% + 0.5px),' +
          'transparent calc(50% + 0.5px)' +
        ');' +
      '}';
    document.head.appendChild(style);
  }

  // ── Combo crosshatch marker ────────────────────────────────────────
  // 16x24" Black Wood and 16x24" Natural Wood variants do not exist —
  // Gelato does not offer that size/frame combination. When 16x24" is
  // selected as the Size, the Black Wood and Natural Wood frame buttons
  // receive a diagonal strikethrough so the customer immediately sees
  // those options are unavailable for that size.
  function init() {
    var picker = document.querySelector('variant-selects');
    if (!picker) return;

    var UNAVAIL_SIZE   = '16x24"';
    var UNAVAIL_FRAMES = ['Black Wood', 'Natural Wood'];

    function update() {
      // Determine whether 16x24" is currently selected
      var sizeRestricted = false;
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (inp) {
        if (inp.value === UNAVAIL_SIZE) sizeRestricted = true;
      });

      // Toggle the strikethrough class on the matching frame labels
      UNAVAIL_FRAMES.forEach(function (frameName) {
        picker.querySelectorAll('input[type="radio"][value="' + frameName + '"]').forEach(function (inp) {
          var lbl = picker.querySelector('label[for="' + inp.id + '"]');
          if (!lbl) return;
          if (sizeRestricted) {
            lbl.classList.add('c9-combo-unavail');
          } else {
            lbl.classList.remove('c9-combo-unavail');
          }
        });
      });
    }

    // Run on load to set initial state
    update();
    // Re-run whenever any variant option changes
    picker.addEventListener('change', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
